import styled from "styled-components";

export const ArticleWrapper = styled.article`
  margin-top: 2rem;
  p {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    display: flex;
    align-items: center;
    text-align: justify;
    text-transform: capitalize;
    @media screen and (max-width: 425px) {
      width: 360px;
      height: auto;
    }
    @media screen and (max-width: 390px) {
      width: 340px;
    }
    @media screen and (max-width: 375px) {
      width: 300px;
    }
    @media screen and (max-width: 320px) {
      width: 240px;
    }
    @media screen and (max-width: 280px) {
      width: 210px;
    }
  }
`;
